import { useState } from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '@/components/feature/SEOHead';
import { categories } from '@/mocks/categories';
import { getPopularArticles, getRecentArticles } from '@/mocks/articles';

export default function Home() {
  const [activeCategoryTab, setActiveCategoryTab] = useState<string>('all');

  const popularArticles = getPopularArticles(6);
  const recentArticles = getRecentArticles(6);
  const displayCategories = activeCategoryTab === 'all'
    ? categories.slice(0, 8)
    : categories.filter((c) => c.slug === activeCategoryTab);

  const schemaData = [
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: '福利社导航 - 首页',
      description: '福利社导航为您汇聚全网最新最全的福利资源入口，精选优质福利社站点，提供便捷的一站式导航服务。',
      url: 'https://fulishe-dh.com/',
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: 'https://fulishe-dh.com/' },
        ],
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: '福利社导航是什么？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '福利社导航是一个专业的福利资源聚合平台，致力于为中文互联网用户提供精选福利资源的快速入口。我们每日更新收录各大平台的福利活动、优惠券、会员权益等信息，让用户一站直达所需资源。',
          },
        },
        {
          '@type': 'Question',
          name: '福利社导航的资源多久更新一次？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '福利社导航坚持每日更新，我们的编辑团队实时追踪全网福利动态，确保收录的资源信息准确、及时。重要福利活动会在第一时间更新到对应分类中。',
          },
        },
        {
          '@type': 'Question',
          name: '如何使用福利社导航找到想要的资源？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '您可以通过首页的分类导航快速定位感兴趣的福利类型，也可以使用搜索功能查找特定资源。每个分类页面都包含了该类别下最热门的福利资源，点击即可查看详情并获取。',
          },
        },
        {
          '@type': 'Question',
          name: '福利社导航提供的资源是否安全可靠？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '我们严格审核收录的每一个资源入口，确保来源正规可靠。福利社导航仅提供资源入口导航，不会要求用户提供任何个人信息或账号密码，用户可以放心使用。',
          },
        },
        {
          '@type': 'Question',
          name: '如何推荐好的福利资源给福利社导航？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '我们非常欢迎用户推荐优质福利资源！您可以通过关于我们页面的联系表单提交推荐信息，我们的编辑团队会尽快审核并收录到相应分类中。',
          },
        },
      ],
    },
  ];

  return (
    <>
      <SEOHead
        title="首页"
        description="福利社导航为您汇聚全网最新最全的福利资源入口，精选优质福利社站点，提供便捷的一站式导航服务。"
        keywords="福利社导航,福利社导航入口,福利社网站导航,福利资源导航,福利社精选推荐,福利导航大全,福利社最新地址"
        canonicalUrl="https://fulishe-dh.com/"
        schemaData={schemaData}
      />

      <main>
        {/* Hero Section */}
        <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20modern%20abstract%20composition%20with%20soft%20gradients%20in%20amber%20cream%20and%20warm%20gold%20tones%2C%20geometric%20shapes%20floating%20elegantly%2C%20minimalist%20design%20with%20subtle%20texture%2C%20warm%20inviting%20atmosphere%2C%20no%20text%2C%20abstract%20art%20style%2C%20clean%20and%20sophisticated%20background%20for%20a%20navigation%20website&width=1800&height=900&seq=hero-fulishe-2026&orientation=landscape"
            alt="福利社导航 - 精选福利资源一站直达"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40"></div>

          <div className="relative z-10 text-center px-4 w-full max-w-3xl mx-auto">
            <div className="inline-flex items-center gap-2 bg-background-50/20 backdrop-blur-sm rounded-full px-4 py-1.5 mb-6">
              <i className="ri-sparkling-2-line text-accent-400 text-sm"></i>
              <span className="text-xs text-background-50/90">每日更新 · 精选优质福利资源</span>
            </div>
            <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold text-background-50 font-heading mb-4 leading-tight">
              精选福利资源一站直达
            </h1>
            <p className="text-sm md:text-base text-background-50/80 mb-8 max-w-xl mx-auto leading-relaxed">
              福利社导航为您汇聚全网最新最全的福利资源入口，省时省力，持续收录优质资源
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/category/youhuiquan"
                className="bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-3 rounded-lg font-medium text-sm transition-colors whitespace-nowrap cursor-pointer"
              >
                开始探索福利
              </Link>
              <Link
                to="/about"
                className="bg-background-50/20 hover:bg-background-50/30 backdrop-blur-sm text-background-50 px-6 py-3 rounded-lg font-medium text-sm transition-colors whitespace-nowrap cursor-pointer"
              >
                了解更多
              </Link>
            </div>

            {/* Stats */}
            <div className="flex items-center justify-center gap-6 md:gap-10 mt-10">
              <div className="text-center">
                <div className="text-lg md:text-xl font-bold text-background-50">{categories.length * 100}+</div>
                <div className="text-xs text-background-50/60 mt-0.5">收录资源</div>
              </div>
              <div className="w-px h-8 bg-background-50/20"></div>
              <div className="text-center">
                <div className="text-lg md:text-xl font-bold text-background-50">{categories.length}</div>
                <div className="text-xs text-background-50/60 mt-0.5">资源分类</div>
              </div>
              <div className="w-px h-8 bg-background-50/20"></div>
              <div className="text-center">
                <div className="text-lg md:text-xl font-bold text-background-50">50万+</div>
                <div className="text-xs text-background-50/60 mt-0.5">月访问量</div>
              </div>
            </div>
          </div>
        </section>

        {/* Category Section */}
        <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="text-xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
                福利资源分类
              </h2>
              <p className="text-sm text-foreground-600 max-w-lg mx-auto">
                覆盖八大热门福利类别，助您快速找到所需资源
              </p>
            </div>

            {/* Category Tabs */}
            <div className="flex items-center justify-center flex-wrap gap-2 mb-8">
              <button
                onClick={() => setActiveCategoryTab('all')}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  activeCategoryTab === 'all'
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-700 hover:bg-background-200'
                }`}
              >
                全部分类
              </button>
              {categories.map((cat) => (
                <button
                  key={cat.id}
                  onClick={() => setActiveCategoryTab(cat.slug)}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                    activeCategoryTab === cat.slug
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-700 hover:bg-background-200'
                  }`}
                >
                  {cat.name}
                </button>
              ))}
            </div>

            {/* Category Cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
              {displayCategories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="group bg-background-50 border border-background-200/70 rounded-lg p-5 hover:border-primary-300 transition-all cursor-pointer"
                >
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className={`${cat.icon} text-primary-600 text-lg`}></i>
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3 className="text-sm font-semibold text-foreground-950 mb-1 whitespace-nowrap">
                        {cat.name}
                      </h3>
                      <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed mb-2">
                        {cat.description}
                      </p>
                      <span className="text-xs text-primary-600 font-medium">
                        {cat.count} 个资源 →
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Hot Articles Section */}
        <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center justify-between mb-8">
              <div>
                <h2 className="text-xl md:text-3xl font-bold text-foreground-950 font-heading mb-2">
                  热门福利推荐
                </h2>
                <p className="text-sm text-foreground-600">最受用户欢迎的福利资源攻略</p>
              </div>
              <Link
                to="/category/all"
                className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
              >
                查看全部 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {popularArticles.map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all cursor-pointer"
                >
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute top-3 left-3">
                      <span className="bg-accent-500 text-background-50 text-xs px-2.5 py-1 rounded-full font-medium">
                        {article.categoryName}
                      </span>
                    </div>
                  </div>
                  <div className="p-4">
                    <h3 className="text-sm font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors leading-snug">
                      {article.title}
                    </h3>
                    <p className="text-xs text-foreground-500 line-clamp-2 mb-3 leading-relaxed">
                      {article.description}
                    </p>
                    <div className="flex items-center justify-between text-xs text-foreground-400">
                      <span>{article.date}</span>
                      <span className="flex items-center gap-1">
                        <i className="ri-eye-line"></i> {article.views.toLocaleString()}
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Recent Articles Section */}
        <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center justify-between mb-8">
              <div>
                <h2 className="text-xl md:text-3xl font-bold text-foreground-950 font-heading mb-2">
                  最新收录资源
                </h2>
                <p className="text-sm text-foreground-600">每日更新，持续收录优质福利资源</p>
              </div>
            </div>

            <div className="space-y-3">
              {recentArticles.map((article, idx) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="flex flex-col sm:flex-row items-start gap-4 p-4 bg-background-50 border border-background-200/70 rounded-lg hover:border-primary-300 transition-all cursor-pointer group"
                >
                  <div className="flex-shrink-0 w-full sm:w-40 h-24 rounded-md overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1.5">
                      <span className="text-xs text-accent-600 font-medium bg-accent-100 px-2 py-0.5 rounded">
                        {article.categoryName}
                      </span>
                      <span className="text-xs text-foreground-400">{article.date}</span>
                    </div>
                    <h3 className="text-sm font-semibold text-foreground-950 mb-1 group-hover:text-primary-600 transition-colors">
                      {article.title}
                    </h3>
                    <p className="text-xs text-foreground-500 line-clamp-1">
                      {article.description}
                    </p>
                  </div>
                  <div className="flex items-center gap-3 text-xs text-foreground-400 flex-shrink-0">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i> {article.views.toLocaleString()}
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="text-xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
                常见问题
              </h2>
              <p className="text-sm text-foreground-600">关于福利社导航的常见疑问解答</p>
            </div>
            <div className="space-y-3">
              {[
                { q: '福利社导航是什么？', a: '福利社导航是一个专业的福利资源聚合平台，致力于为中文互联网用户提供精选福利资源的快速入口。我们每日更新收录各大平台的福利活动、优惠券、会员权益等信息，让用户一站直达所需资源。' },
                { q: '福利社导航的资源多久更新一次？', a: '福利社导航坚持每日更新，我们的编辑团队实时追踪全网福利动态，确保收录的资源信息准确、及时。重要福利活动会在第一时间更新到对应分类中。' },
                { q: '如何使用福利社导航找到想要的资源？', a: '您可以通过首页的分类导航快速定位感兴趣的福利类型。每个分类页面都包含了该类别下最热门的福利资源，点击即可查看详情并获取。' },
                { q: '福利社导航提供的资源是否安全可靠？', a: '我们严格审核收录的每一个资源入口，确保来源正规可靠。福利社导航仅提供资源入口导航，不会要求用户提供任何个人信息或账号密码，用户可以放心使用。' },
                { q: '如何推荐好的福利资源给福利社导航？', a: '我们非常欢迎用户推荐优质福利资源！您可以通过关于我们页面的联系表单提交推荐信息，我们的编辑团队会尽快审核并收录到相应分类中。' },
              ].map((faq, idx) => (
                <details key={idx} className="group bg-background-50 border border-background-200/70 rounded-lg">
                  <summary className="flex items-center justify-between p-4 cursor-pointer text-sm font-medium text-foreground-950 list-none">
                    {faq.q}
                    <i className="ri-add-line text-foreground-400 group-open:hidden"></i>
                    <i className="ri-subtract-line text-foreground-400 hidden group-open:block"></i>
                  </summary>
                  <div className="px-4 pb-4 text-sm text-foreground-600 leading-relaxed">
                    {faq.a}
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>
      </main>
    </>
  );
}